/* globals Promise */

import moment from 'moment';
import reduce from 'lodash/reduce';
import { ignoreZoomforthUsers } from 'zoomforth_shared_management/lib/analytics_keen_filters.js';
import analyticsDataFetcherStore from 'zoomforth_zf/appglobals/analytics-fetcher-cacher.js';

export const DUMMY_EARLIEST_MOMENT = moment('1970-01-01T00:00:00Z');
export const DUMMY_EARLIEST_UTC_MOMENT = DUMMY_EARLIEST_MOMENT.utc();
const FLOOR_MODULO_MS = 1000 * 60 * 30;

/*
  Return a new moment js object rounded to the nearest,
  30 mins interval less than the given moment js object
  (i.e., a "floor" operation)
*/
export function floorMoment(momentToFloor, moduloMs=FLOOR_MODULO_MS) {
  return moment(momentToFloor - (momentToFloor % moduloMs));
}


const makePageVisitCountQuery = () => 
  ({
    analysis_type: 'count_unique',
    event_collection: 'resource_accesses-account_' + getAccount().id,
    group_by: 'lens.id',
    target_property: 'user.page_session_uuid',
    timeframe: {
      start: DUMMY_EARLIEST_UTC_MOMENT.format(),
      // We always "floor" to 30 minutes so that we can effectively
      // cache this request. We use UTC so the cache is the same for 
      // users in different timezones
      end: floorMoment(moment()).utc().format()
    },
    filters: ignoreZoomforthUsers().concat([{
      'property_name': 'action',
      'operator': 'eq',
      'property_value': 'page_load'
    }, {
      'property_name': 'lens.id', // probably uncessary
      'operator': 'exists',
      'property_value': true
    }])
  });


export const fetchPageVisitCountByPageId = ()=>
  new Promise((resolve, reject)=> {
    var analyticsDataFetcher = analyticsDataFetcherStore.get();

    const siteVisitsCountById = analyticsDataFetcher
      .request()
      .sites_visits()
      .params({
        startDate: DUMMY_EARLIEST_MOMENT,
        endDate: floorMoment(moment()),
        fetch_from_keen: false,
        extra_filters: {
          shouldIgnoreZfUsers: true
        }
      })
      .group_by(['lens.id'])
      .count();

    siteVisitsCountById
      .then(({ data }) => {
        resolve(data);
      })
      .fail(reject);
  });
